<template>
	<div id="emptycontent">
		<div class="icon-mail"></div>
		<h2>{{ t('mail', 'No messages in this folder') }}</h2>
	</div>
</template>

<script>
export default {
	name: 'EmptyMailbox',
}
</script>
